const WishlistHeartIconWithDot = ({ heartColor = 'black', circleColor = 'white' }) => {
  return (
    <svg
      width="30"
      height="29"
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_68_3380"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="29"
      >
        <rect x="0.294128" width="29" height="29" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_68_3380)">
        <path
          d="M14.7942 24.5609L13.4605 23.3619C11.4575 21.5448 9.80103 19.9833 8.4912 18.6775C7.18137 17.3715 6.14341 16.2092 5.37733 15.1906C4.61124 14.1722 4.07605 13.243 3.77175 12.4033C3.46725 11.5637 3.315 10.7117 3.315 9.84733C3.315 8.1325 3.89319 6.6968 5.04956 5.54023C6.20614 4.38385 7.64184 3.80566 9.35667 3.80566C10.4115 3.80566 11.4084 4.05237 12.3473 4.54577C13.2862 5.03917 14.1018 5.74675 14.7942 6.66851C15.4865 5.74675 16.3022 5.03917 17.241 4.54577C18.1799 4.05237 19.1768 3.80566 20.2317 3.80566C21.9465 3.80566 23.3822 4.38385 24.5388 5.54023C25.6951 6.6968 26.2733 8.1325 26.2733 9.84733C26.2733 10.7117 26.1211 11.5637 25.8166 12.4033C25.5123 13.243 24.9771 14.1722 24.211 15.1906C23.4449 16.2092 22.4089 17.3715 21.1029 18.6775C19.7971 19.9833 18.1387 21.5448 16.1279 23.3619L14.7942 24.5609ZM14.7942 22.1119C16.7275 20.3723 18.3185 18.8812 19.5671 17.6387C20.8157 16.3963 21.8025 15.317 22.5275 14.4006C23.2525 13.4843 23.756 12.6706 24.0379 11.9595C24.3199 11.2486 24.4608 10.5445 24.4608 9.84733C24.4608 8.639 24.0581 7.63205 23.2525 6.8265C22.4469 6.02094 21.44 5.61816 20.2317 5.61816C19.2775 5.61816 18.3956 5.88883 17.586 6.43016C16.7766 6.9717 16.1357 7.72499 15.6633 8.69005H13.9251C13.4448 7.71714 12.8018 6.96193 11.9963 6.42442C11.1907 5.88692 10.3108 5.61816 9.35667 5.61816C8.15599 5.61816 7.15096 6.02094 6.34158 6.8265C5.53219 7.63205 5.1275 8.639 5.1275 9.84733C5.1275 10.5445 5.26847 11.2486 5.55042 11.9595C5.83236 12.6706 6.33584 13.4843 7.06084 14.4006C7.78584 15.317 8.77264 16.3944 10.0213 17.6329C11.2699 18.8715 12.8608 20.3645 14.7942 22.1119Z"
          fill={heartColor}
        />
        <circle
          cx="24.1764"
          cy="5.11765"
          r="4.26471"
          fill={heartColor}
          stroke={circleColor}
          stroke-width="1.70588"
        />
      </g>
    </svg>
  );
};

export default WishlistHeartIconWithDot;
